export default "__VITE_ASSET__Cin_ugHI__"